import { useNavigate } from 'react-router';
import * as R from '@/Router/routes';
import { Application } from '@/api/getClientApplication';

function useNavigateWithBudgetResolution() {
  const navigate = useNavigate();
  const navigateWithBudgetResolution = (application: Application): void => {
    if (
      application?.resolution === 'REJECTED' &&
      application?.resolutionDetail !== 'UPSALE_OFFER' &&
      application?.resolutionDetail !== 'NEW_OFFER'
    ) {
      navigate(R.LOAN_REJECTED);
      return;
    }

    if (
      application?.resolution === 'REJECTED' &&
      application?.resolutionDetail === 'UPSALE_OFFER'
    ) {
      navigate(R.NEW_OFFER_INCREASED);
      return;
    }

    if (
      application?.resolution === 'REJECTED' &&
      application?.resolutionDetail === 'NEW_OFFER'
    ) {
      navigate(R.NEW_OFFER_DECREASED);
      return;
    }

    if (
      application?.resolution === 'MANUAL' &&
      application?.resolutionMessage === 'ASK_FOR_DOCUMENTS'
    ) {
      navigate(R.EXPIRED_INCOME);
      return;
    }

    if (
      application?.resolution === 'MANUAL' &&
      application?.resolutionDetail === 'INSUFFICIENT_PSD2_INCOME'
    ) {
      navigate(R.ADJUST_INCOME);
      return;
    }

    if (
      application?.resolution === 'MANUAL' &&
      application?.resolutionMessage !== 'ASK_FOR_DOCUMENTS' &&
      application?.resolutionDetail !== 'INSUFFICIENT_PSD2_INCOME'
    ) {
      navigate(R.DOCUMENT_UPLOAD_PENDING);
      return;
    }

    // default redirect
    navigate(R.LOAN_CONFIRM);
  };

  return { navigateWithBudgetResolution };
}

export default useNavigateWithBudgetResolution;
